__turbopack_context__.v({
  "carouselImage": "DesktopCarousel-module__IQmr1W__carouselImage",
  "root": "DesktopCarousel-module__IQmr1W__root",
});
